export const RESPONSE_ID_PREFIX = 'id_make_response_';
export const MARKDOWN_HEADING_OFFSET = 3;
